import React from 'react'
import HighlightItem from './HighlightItem'

function FeaturesList() {
  return (
    <div className="account-subscription__highlights">
      <p className="account-subscription__highlights-title">Особенности подписки</p>
      <ul className="account-subscription__highlights-list">
        {[
          'Подписка продлевается автоматически, если она не была отменена самим пользователем',
          'После отмены подписки она продолжает действовать до конца оплаченного срока',
          'Поменять вариант подписки можно в любой момент, изменения вступят в силу после уже оплаченного периода'
        ].map((item, index) => (
          <HighlightItem {...{ item }} key={index} />
        ))}
      </ul>
    </div>  
  )
}

export default React.memo(FeaturesList)